const GA4_ID = process.env.REACT_APP_GA4_ID;
let analyticsInitialized = false;

const hasGtag = () => typeof window !== 'undefined' && typeof window.gtag === 'function';

export const initAnalytics = () => {
  if (!GA4_ID || analyticsInitialized || typeof window === 'undefined') {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  const scriptSrc = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  const existingScript = document.querySelector(`script[src="${scriptSrc}"]`);
  if (!existingScript) {
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);
  }

  window.gtag('js', new Date());
  window.gtag('config', GA4_ID, { send_page_view: false });
  analyticsInitialized = true;
};

export const trackPageView = (path) => {
  if (!GA4_ID || !hasGtag()) {
    return;
  }

  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
};

export const trackEvent = (eventName, eventParams = {}) => {
  if (!GA4_ID || !hasGtag()) {
    return;
  }

  window.gtag('event', eventName, eventParams);
};
